module.exports = "/images/user-sharp-regular.svg?57b235c47059153d4c5d2231f8906d3f";